var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._v("\n  没有配置.vue相应的url地址，叶子节点必须配置url，请检查\n  'activeIndex'-"+_vm._s(_vm.activeIndex)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }